import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=3f8a4a33&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=3f8a4a33&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8a4a33",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shimoyamadayuu/Documents/github/management-site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f8a4a33')) {
      api.createRecord('3f8a4a33', component.options)
    } else {
      api.reload('3f8a4a33', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=3f8a4a33&scoped=true", function () {
      api.rerender('3f8a4a33', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/messages/Index.vue"
export default component.exports